export default __webpack_public_path__ + "media/color/rdn-0dfb7dd0.svg";